import { render, staticRenderFns } from "./OuathComponent.vue?vue&type=template&id=8ff97bd2"
import script from "./OuathComponent.vue?vue&type=script&lang=js"
export * from "./OuathComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports